
import {Component, Vue} from 'vue-property-decorator';
import ContratoViewComponent from "@/components/ContratoViewComponent.vue"

@Component({
  name: "ContratoNew",
  components: {
    ContratoViewComponent
  }
})
export default class ContratoNew extends Vue {
}
